import React, { useEffect, useState } from "react";
import {ArrowDropDown as ArrowDropDownIcon} from "@mui/icons-material";
import { Box, Button, TextField, Typography } from "@mui/material";
import "./CountryAutocomplete.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CountrySelection from "../CountrySelection/CountrySelection";
import { LOCALIZATION } from "../../utils/localization";
import { t } from "i18next";

const CountryAutocomplete = ({
  setIsOtpScreen,
  sendOtp,
  setPhone,
  preOtpErrorMsg,
  setPreOtpErrorMsg,
  selectedDialCode,
  setSelectedDialCode,
  disableGuestButton,
}: any) => {
  const [openCountryDialog, setOpenCountryDialog] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState(
    "https://flagcdn.com/w320/in.png"
  );
  const { countryCode } = useSelector((state: any) => state.auth);
  const [mobileNumber, setMobileNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");

  let maxAllowedLength = 13;
  if (selectedDialCode?.length === 1) {
    maxAllowedLength = 12;
  }
  const handleClickOpenCountryDialog = () => {
    setOpenCountryDialog(true);
  };

  useEffect(() => {
    if (countryCode && countryCode.length > 0) {
      const filteredCountry = countryCode?.filter(
        (item: any) => item?.code === "IN"
      );
      setSelectedDialCode(filteredCountry[0].dial_code);
      setSelectedCountry(filteredCountry[0].code);
      setSelectedFlag(
        `https://flagcdn.com/w320/${
          filteredCountry[0] && filteredCountry[0].code
            ? filteredCountry[0].code.toLowerCase()
            : "in"
        }.png`
      );
    }
  }, [countryCode]);
  useEffect(() => {
    setPhone(mobileNumber);
  }, [mobileNumber]);

  const handleClose = (value: {
    flag: string;
    dialCode: string;
    code: string;
  }) => {
    setOpenCountryDialog(false);

    if (typeof value !== "undefined") {
      setSelectedFlag(value.flag);
      setSelectedDialCode(value.dialCode);
      setSelectedCountry(value.code);
    }
  };

  const handleProceedClick = (e: any) => {
    e.preventDefault();
    // Only allow numbers in input
    if (/^\d*$/.test(mobileNumber)) {
      // Check if the number is exactly 10 digits
      if (mobileNumber.length === 10) {
        setError(""); // No error if length is 10
      } else {
        setError("Mobile number should be exactly 10 digits.");
        return;
      }
    } else {
      setError("Mobile number should be exactly 10 digits and numeric only.");
      return;
    }
    const phoneWithCode = `${mobileNumber}`;
    if (phoneWithCode?.trim().length > 0 && selectedDialCode.length > 0) {
      sendOtp(selectedDialCode);
      // setIsOtpScreen(true);
    }
  };
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleProceedClick(event);
    }
  };
  const handleGuestClick = () => {
    navigate("/");
  };

  return (
    <Box className="loginCard">
      <Typography variant="h1" className="newAccountTitle">
        {t(LOCALIZATION.Create_a)} <br /> {t(LOCALIZATION.New_Account)}
      </Typography>
      <Box className="line"></Box>
      <Box className="leftAlignText">
        <Typography variant="h6" className="subTitleText">
          {t(LOCALIZATION.Spiritual_Experience_with)} <br />
          <span className="boldText">{t(LOCALIZATION.Temple_Dekho)}</span>
        </Typography>
        <Typography className="loginPhNoText">
          {t(LOCALIZATION.LOGIN_SIGNUP_WITH_Your_Mobile_Number)}
        </Typography>
      </Box>

      <Box className="countryInputArea">
        <button className="flagImgBtn" onClick={handleClickOpenCountryDialog}>
          <img src={selectedFlag} alt="Selected Country Flag" />
          <ArrowDropDownIcon className="dropdownIcon" />
        </button>

        <CountrySelection
          open={openCountryDialog}
          onClose={handleClose}
          selectedDialCode={selectedDialCode}
          selectedCountryCode={selectedCountry}
        />

        <TextField
          className="phNoInput"
          label={t(LOCALIZATION.Mobile_Number)}
          fullWidth
          variant="standard"
          value={`${selectedDialCode || ""} ${mobileNumber || ""}`}
          onChange={(e) => {
            setPreOtpErrorMsg("");
            setError("");
            setMobileNumber(
              e.target.value
                .replace(selectedDialCode || "", "")
                .replace(/[^0-9]/g, "")
                .trim()
            );
          }}
          inputProps={{
            inputMode: "numeric", // Displays a numeric keyboard on mobile devices
            pattern: "[0-9]*", // Ensures only numeric input
            maxLength: maxAllowedLength,
          }}
          error={!!error || preOtpErrorMsg}
          helperText={error ? error : preOtpErrorMsg ? preOtpErrorMsg : ""}
          onKeyDown={handleKeyDown} // Attach the keydown event for ENTER from keyboard
        />
      </Box>

      <Box className="bottomButtonGroup">
        <Button
          className="proceedBtn"
          onClick={handleProceedClick}
          disabled={mobileNumber?.length === 0}
        >
          {t(LOCALIZATION.PROCEED)}
        </Button>
        {!disableGuestButton && (
          <Button className="guestBtn" onClick={handleGuestClick}>
            {t(LOCALIZATION.Continue_as_a_guest)}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default CountryAutocomplete;
